import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, SvgIcon, Tooltip } from '@mui/material';
import WrenchScrewdriverIcon from '@heroicons/react/24/solid/WrenchScrewdriverIcon';
import SparklesIcon from '@heroicons/react/24/solid/SparklesIcon';
const responsiveButtonSx = {
    minWidth: { xs: 40, md: 'auto' },
    minHeight: { xs: 40, md: 'auto' },
    width: { xs: 40, md: 'auto' },
    height: { xs: 40, md: 'auto' },
    px: { xs: 0, md: 2 },
    borderRadius: { xs: '50%', md: 1 },
    justifyContent: { xs: 'center', md: 'flex-start' },
    '& .MuiButton-startIcon': {
        margin: { xs: 0, md: '0 8px 0 0' },
    },
};
export const ToolsAndChangelogButtons = () => (_jsxs(_Fragment, { children: [_jsx(Tooltip, { title: 'starjack.Tools', children: _jsx(Button, { id: 'starjack-tools-button', startIcon: _jsx(SvgIcon, { fontSize: 'small', children: _jsx(WrenchScrewdriverIcon, {}) }), sx: responsiveButtonSx, children: _jsx(Box, { component: 'span', sx: { display: { xs: 'none', md: 'inline' } }, children: "starjack.Tools" }) }) }), _jsx(Tooltip, { title: "What's new", children: _jsx(Button, { id: 'changelog-button', startIcon: _jsx(SvgIcon, { fontSize: 'small', children: _jsx(SparklesIcon, {}) }), sx: responsiveButtonSx, children: _jsx(Box, { component: 'span', sx: { display: { xs: 'none', md: 'inline' } }, children: "What's new" }) }) })] }));
